import { render, staticRenderFns } from "./LoginVersao.vue?vue&type=template&id=573269a6"
import script from "./LoginVersao.vue?vue&type=script&lang=js"
export * from "./LoginVersao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports